<template>
    <div class="ecology">
        <div class="pc" v-if="equipment == 'pc'">
            <navig :w="w" :only="only" />
            <div class="header">
                <img src="~img/ContactUs/30.png" class="logo-img" />
                <h5>安谋科技合规与知识产权监督联络反馈</h5>
                <div class="heng"></div>
                <p class="title">
                    安谋科技始终秉持合法合规、尊重创新的理念，高度重视合规管理及知识产权保护，坚决反对任何违反法律法规、商业道德及侵犯公司合法权益的行为。
                </p>
                <!-- <p class="title title_two">
                    安谋科技将依托成熟的Arm技术生态与自研业务产品矩阵，通过战略合作、产品技术支持、协作项目以及联合营销等多种形式，与联合实验室成员共建人工智能平台及其上下游产业生态，推动人工智能技术的应用落地，促进中国人工智能产业的创新与繁荣。
                </p> -->
                <!-- 安谋科技始终秉持合法合规、尊重创新的理念，高度重视合规管理及知识产权保护，坚决反对任何违反法律法规、商业道德及侵犯公司合法权益的行为。

为建立便捷有效的外部反馈渠道，我们特设立以下专用举报邮箱：
·  合规举报（如反腐败、反商业贿赂）：compliance@armchina.com
·  侵权举报：ipr@armchina.com

我们欢迎客户、合作伙伴及社会各界与我们联系反馈，同时承诺对举报人信息严格保密，并依法依规及时开展核实与处理。

安谋科技期待与各方携手，维护公平竞争、创新发展的良好环境。 -->
                <p class="lianjie">
                    为建立便捷有效的外部反馈渠道，我们特设立以下专用举报邮箱：<br />
                    · 合规举报（如反腐败、反商业贿赂）： <a href="mailto:compliance@armchina.com"
                        target="_blank">compliance@armchina.com</a> <br />
                    · 侵权举报： <a href="mailto:ipr@armchina.com" target="_blank">ipr@armchina.com</a>
                </p>
                <p class="lianjie">我们欢迎客户、合作伙伴及社会各界与我们联系反馈，同时承诺对举报人信息严格保密，并依法依规及时开展核实与处理。</p>
                <p class="lianjie" style="margin-bottom: 4rem;">安谋科技期待与各方携手，维护公平竞争、创新发展的良好环境。</p>
                <img src="~img/ContactUs/2x.png" class="bg-img" />
            </div>
            <pc-footer :showFooter="showFooter" />
        </div>
        <div class="web" v-if="equipment == 'web'">
            <web-nav />
            <div class="header">
                <img src="~img/ContactUs/33.png" class="bg-img" />
                <img src="~img/ContactUs/31.png" class="logo-img" />
                <h5>安谋科技合规与知识产权监督联络反馈</h5>
                <div class="heng"></div>
                <p class="title">
                    安谋科技始终秉持合法合规、尊重创新的理念，高度重视合规管理及知识产权保护，坚决反对任何违反法律法规、商业道德及侵犯公司合法权益的行为。
                </p>
                <!-- <p class="title title_two">
                    安谋科技将依托成熟的Arm技术生态与自研业务产品矩阵，通过战略合作、产品技术支持、协作项目以及联合营销等多种形式，与联合实验室成员共建人工智能平台及其上下游产业生态，推动人工智能技术的应用落地，促进中国人工智能产业的创新与繁荣。
                </p> -->
                <p class="lianjie">
                    为建立便捷有效的外部反馈渠道,我们特设立以下专用举报邮箱：<br />
                    · 合规举报（如反腐败、反商业贿赂）：<a href="mailto:ai-joint-lab@armchina.com"
                        target="_blank">ai-joint-lab@armchina.com</a><br />
                    · 侵权举报： <a href="mailto:ipr@armchina.com" target="_blank">ipr@armchina.com</a>
                </p>
                <p class="lianjie" style="padding-right: 15px;">我们欢迎客户、合作伙伴及社会各界与我们联系反馈，同时承诺对举报人信息严格保密，并依法依规及时开展核实与处理。
                </p>
                <p class="lianjie" style="padding-right: 15px;">安谋科技期待与各方携手，维护公平竞争、创新发展的良好环境。</p>
                <div class="foot">
                    <web-footer />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navig from '@/components/navigation.vue' // pc 导航
import pcFooter from '@/components/pcFooter.vue' // pc 底部
import webNav from '@/components/webNav.vue' // web 导航
import webFooter from '@/assembly/web/webFooter.vue' // web 底部
import up from '@/components/Backtotop.vue'
export default {
    components: {
        navig,
        pcFooter,
        webNav,
        webFooter,
        up,
    },
    data() {
        return {
            w: '',
            equipment: '',
            only: true,
            showFooter: true,
        }
    },
    created() {
        this.w = document.documentElement.offsetWidth || document.body.offsetWidth
        if (this.w <= 750) {
            this.equipment = 'web'
        } else {
            this.equipment = 'pc'
        }
        document.title = '合规与IP监督联络反馈'
    },
    mounted() {
        window.onresize = () => {
            // 动态检测宽度变化
            return (() => {
                this.w = document.body.clientWidth
                if (this.w <= 750) {
                    this.equipment = 'web'
                } else {
                    this.equipment = 'pc'
                }
            })()
        }
    },
}
</script>

<style lang="less" scoped>
.ecology {
    min-height: 100vh;

    .pc {
        background-image: linear-gradient(#fff, #000 10%);

        .header {
            background-color: rgba(0, 0, 0, 0.6);
            min-height: 7.08rem;
            padding-top: 3.23rem;

            h5 {
                z-index: 9;
                position: relative;
            }

            p {
                z-index: 9;
                position: relative;
            }

            .bg-img {
                width: 100%;
                position: absolute;
                top: 0;
                left: 0;
            }

            .logo-img {
                position: absolute;
                right: 0.75rem;
                top: 2.86rem;
                width: 0.38rem;
            }

            .heng {
                width: 1.66rem;
                height: 0.03rem;
                background: #00b3d6;
                margin-top: 0.24rem;
                margin-bottom: 0.5rem;
                margin-left: 1.35rem;
            }

            h5 {
                font-size: 0.4rem;
                color: #fff;
                font-weight: bold;
                margin-left: 1.35rem;
            }

            .title {
                font-size: 0.2rem;
                color: #fff;
                line-height: 0.38rem;
                margin-left: 1.35rem;
                margin-right: 1.47rem;
            }

            .title_two {
                margin-top: 0.4rem;
            }

            .content {
                h6 {
                    font-size: 0.36rem;
                    color: #fff;
                    text-align: center;
                    margin-top: 0.8rem;
                }

                ul {
                    padding-left: 2.5rem;
                    padding-right: 2.5rem;
                    display: flex;
                    margin-top: 0.8rem;

                    li {
                        width: 25%;

                        img {
                            width: 1.29rem;
                            height: 1.48rem;
                            margin: auto;
                        }

                        p {
                            text-align: center;
                            color: #a1a1a1;
                            font-size: 0.2rem;
                            margin-top: 0.19rem;
                        }
                    }
                }
            }

            .lianjie {
                margin-left: 1.35rem;
                margin-top: 0.4rem;
                font-size: 0.2rem;
                // padding-bottom: 1.13rem;
                color: #fff;
                position: relative;
                line-height: .4rem;

                a {
                    color: #00b4d4;
                    // text-decoration: underline;
                    // border-bottom: width style color;
                    border-bottom: 1px solid #00b4d4;
                }
            }

            .joinas {
                .fege {
                    width: 1.16rem;
                    height: 0.03rem;
                    margin-left: 1.35rem;
                    margin-top: 0.24rem;
                    background: #00b3d6;
                }

                h5 {
                    font-size: 0.3rem;
                }

                h6 {
                    font-size: 0.2rem;
                    color: #fff;
                    margin-left: 1.35rem;
                    margin-top: 0.47rem;
                    margin-bottom: 0.78rem;

                    span {
                        color: #00b3d6;
                        text-decoration: underline;
                        cursor: pointer;
                    }
                }
            }
        }
    }

    .web {
        background-image: linear-gradient(#fff, #000 15%);
        position: relative;

        .header {
            background: rgba(0, 0, 0, 0.9);
            padding-top: 150px;

            .logo-img {
                width: 45%;
                float: right;
                margin-right: 20px;
                z-index: 99;
                position: relative;
            }

            .bg-img {
                position: absolute;
                top: 0;
                left: 0;
            }

            h5 {
                font-size: 20px;
                color: #fff;
                margin-top: 60px;
                margin-left: 40px;
                position: relative;
                z-index: 99;
            }

            .level2 {
                font-size: 16px;
            }

            .heng {
                width: 100px;
                height: 2px;
                background: #00b3d6;
                margin-left: 40px;
                margin-top: 10px;
            }

            .title {
                font-size: 12px;
                color: #fff;
                margin-left: 40px;
                width: 80%;
                margin-top: 20px;

                span {
                    color: #00b3d6;
                    text-decoration: underline;
                }
            }

            .content {
                padding-top: 40px;

                h6 {
                    font-size: 20px;
                    color: #fff;
                    text-align: center;
                    margin-bottom: 25px;
                }

                ul {
                    display: flex;
                    flex-wrap: wrap;
                    width: 80%;
                    margin: auto;

                    li {
                        width: 50%;
                        margin-bottom: 30px;

                        img {
                            width: 50%;
                            margin: auto;
                        }

                        p {
                            text-align: center;
                            color: #a1a1a1;
                            margin-top: 10px;
                        }
                    }
                }
            }

            .lianjie {
                color: #fff;
                font-size: 12px;
                margin-left: 40px;
                margin-top: 30px;
                line-height: 25px;

                a {
                    border-bottom: 1px solid #00b4d4;
                    font-size: 13px;
                }
            }

            .foot {
                position: relative;
                padding-bottom: 10px;
                background-color: #000;
            }
        }
    }
}
</style>
